<template>
  <footer class="site-footer">
    <div class="footer-legal">
      <div class="content-max-width flex">
        <p class="copyright">&copy; Pool Focus 2021</p>

        <a :href="data.email.link" class="email">{{ data.email.title }}</a>

        <a
          href="https://fromhere.nz/"
          target="_blank"
          class="attribution"
        >Website From Here</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: [
    'data'
  ]
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue